import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Layout from '../Layout/Layout';

export default function Spinner() {
  return (
    <Layout plain>
      <h3 className="mt-5">
        <FontAwesomeIcon icon={faSpinner} spin pulse className="text-muted" />{' '}
        Loading...
      </h3>
      <p className="lead">Please wait..</p>
    </Layout>
  );
}
